import {Component, inject, OnInit} from '@angular/core';
import {NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-product-list',
    imports: [NgIf, RouterLink, FormsModule],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-box me-2"></i>Produkte <small class="text-muted">({{entries?.length}})</small></h3>
                </div>

                <div class="mb-3 d-flex flex-wrap justify-content-between gap-2">
                    <div class="d-flex flex-wrap gap-2">
                        <button type="button" class="btn btn-primary" [routerLink]="['/product', 0]">Produkt anlegen</button>
                    </div>

                    <div class="d-flex flex-wrap gap-2">
                        <button type="button" class="btn btn-info" (click)="export('obligatory')">
                            <i class="fa-solid fa-file-pdf"></i>Verpflichtendes Verkaufssortiment
                        </button>
                        <button type="button" class="btn btn-info" (click)="export()">
                            <i class="fa-solid fa-file-pdf"></i>Komplettes Verkaufssortiment
                        </button>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-striped table-hover mb-0 pointer">
                        <thead>
                        <tr>
                            <th style="width: 150px" (click)="setOrder('article_number')">
                                Artikelnummer <i class="fa-solid" *ngIf="predicate == 'article_number'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th style="width: 150px" (click)="setOrder('number')">
                                Nummer <i class="fa-solid" *ngIf="predicate == 'number'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('name')">
                                Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th style="width: 250px" (click)="setOrder('product_group_name')">
                                Produktgruppe <i class="fa-solid" *ngIf="predicate == 'product_group_name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th style="width: 150px" (click)="setOrder('product_type')">
                                Typ <i class="fa-solid" *ngIf="predicate == 'product_type'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th style="width: 150px" (click)="setOrder('status')">
                                Status <i class="fa-solid" *ngIf="predicate == 'status'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th style="width: 100px" (click)="setOrder('active')">
                                Aktiv <i class="fa-solid" *ngIf="predicate == 'active'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" class="form-control" [(ngModel)]="filter.article_number" (ngModelChange)="setFilter()" [class.search-active]="filter.article_number">
                            </td>
                            <td></td>
                            <td>
                                <input type="text" class="form-control" [(ngModel)]="filter.name" (ngModelChange)="setFilter()" [class.search-active]="filter.name">
                            </td>
                            <td>
                                <select class="form-select" [(ngModel)]="filter.product_group" (ngModelChange)="setFilter()" [class.search-active]="filter.product_group">
                                    <option value="">Alle Gruppen</option>
                                    @for (productGroup of productGroups; track productGroup) {
                                        <option [value]="productGroup">{{ productGroup }}</option>
                                    }
                                </select>
                            </td>
                            <td>
                                <select class="form-select" [(ngModel)]="filter.product_type" (ngModelChange)="setFilter()" [class.search-active]="filter.product_type">
                                    <option value="">Alle Typen</option>
                                    @for (productType of productTypes; track productType) {
                                        <option [value]="productType">{{ productType }}</option>
                                    }
                                </select>
                            </td>
                            <td>
                                <select class="form-select" [(ngModel)]="filter.product_status" (ngModelChange)="setFilter()" [class.search-active]="filter.product_status">
                                    <option value="">Alle Status</option>
                                    @for (status of productStatus; track status) {
                                        <option [value]="status">{{ status }}</option>
                                    }
                                </select>
                            </td>
                            <td>
                                <select class="form-select" [(ngModel)]="filter.active" (ngModelChange)="setFilter()" [class.search-active]="filter.active">
                                    <option value="">Alle</option>
                                    <option value="1">Ja</option>
                                    <option value="0">Nein</option>
                                </select>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/product', entry.id]">
                                <td>{{ entry.article_number }}</td>
                                <td>{{ entry.number }}</td>
                                <td>{{ entry.name }}</td>
                                <td>{{ entry.product_group_name }}</td>
                                <td>{{ entry.product_type }}</td>
                                <td>{{ entry.status }}</td>
                                <td>{{ entry.active == '1' ? 'Ja' : 'Nein' }}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class ProductListComponent implements OnInit {

    private dataService = inject(DataService);

    allEntries!: any[] | null;
    entries!: any[] | null;
    filter: any = {
        article_number: '',
        name: '',
        product_group: '',
        product_type: '',
        product_status: '',
        active: '',
    };
    productGroups: string[] = [];
    productTypes: string[] = [];
    productStatus: string[] = [];

    predicate = 'article_number';
    reverse = false;

    ngOnInit(): void {
        this.listEntries();
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.listEntries();
    }

    listEntries(): void {
        this.entries = null;
        this.dataService.request('Product/listAll', {
            order: this.predicate,
            reverse: this.reverse,
        }).subscribe(response => {
            this.allEntries = response.products;

            this.productGroups = response.products.map(product => product.product_group_name);
            this.productGroups = [...new Set(this.productGroups)];

            this.productTypes = response.products.map(product => product.product_type);
            this.productTypes = [...new Set(this.productTypes)];

            this.productStatus = response.products.map(product => product.status);
            this.productStatus = [...new Set(this.productStatus)];

            this.setFilter();
        });
    }

    protected setFilter() {
        this.entries = this.allEntries;

        if (this.filter.article_number != "") {
            this.entries = this.entries.filter(entry => entry.article_number.includes(this.filter.article_number));
        }
        if (this.filter.name != "") {
            this.entries = this.entries.filter(entry => entry.name.toLowerCase().includes(this.filter.name.toLowerCase()));
        }
        if (this.filter.product_group != "") {
            this.entries = this.entries.filter(entry => entry.product_group_name == this.filter.product_group);
        }
        if (this.filter.product_type != "") {
            this.entries = this.entries.filter(entry => entry.product_type == this.filter.product_type);
        }
        if (this.filter.product_status != "") {
            this.entries = this.entries.filter(entry => entry.status == this.filter.product_status);
        }
        if (this.filter.active != "") {
            this.entries = this.entries.filter(entry => entry.active == this.filter.active);
        }
    }

    export(type: string = 'all'): void {
        this.dataService.request("Product/export", {
            type: type,
        }).subscribe(response => {
            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = response.filename;
                //a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                setTimeout(() => URL.revokeObjectURL(url), 100);
            }
        });
    }
}
